/**
 * Cart drawer: immediate line prices + estimated total after add/remove/qty.
 * BSS B2B: Shopify cart.total_price is often retail — sum line totals instead.
 */
(function () {
  var MONEY_FORMAT =
    window.mtCartMoneyFormat ||
    (window.Shopify && Shopify.money_with_currency_format) ||
    (typeof afterpay_shop_money_format !== 'undefined' && afterpay_shop_money_format) ||
    (window.Shopify && Shopify.money_format) ||
    '${{amount}}';

  var LINE_MONEY_FORMAT =
    window.mtCartLineMoneyFormat ||
    (typeof afterpay_shop_money_format !== 'undefined' && afterpay_shop_money_format) ||
    (window.Shopify && Shopify.money_format) ||
    '${{amount}}';

  var syncGen = 0;
  var reqSeq = 0;
  var minReq = 0;
  var lastAppliedReq = 0;
  var lastGoodCart = null;
  var lastDisplayTotal = 0;
  var lockedMoney = null;
  var lockedGen = 0;
  var lockTimer = null;
  var totalObserver = null;
  var lineObserver = null;
  var drawerObserver = null;
  var pendingApply = null;
  var reapplyQueued = false;

  function formatMoney(cents, format) {
    var f = format || MONEY_FORMAT;
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, f);
    }
    // Honor the store's own money-format template so JS-repainted values match
    // the server render exactly (Intl would show "A$" for AUD).
    var amount = ((Number(cents) || 0) / 100).toFixed(2);
    if (f && f.indexOf('{{amount}}') !== -1) {
      return f.replace(/\{\{\s*amount\s*\}\}/g, amount);
    }
    var currency = window.mtCartCurrencyCode || 'AUD';
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency,
      }).format((Number(cents) || 0) / 100);
    } catch (e) {
      return amount + ' ' + currency;
    }
  }

  function beginCartSync() {
    syncGen += 1;
    minReq = ++reqSeq;
    lastGoodCart = null;
    lastDisplayTotal = 0;
    pendingApply = null;
    lockedMoney = null;
    lockedGen = 0;
    if (lockTimer) {
      clearTimeout(lockTimer);
      lockTimer = null;
    }
    if (totalObserver) {
      totalObserver.disconnect();
      totalObserver = null;
    }
    if (lineObserver) {
      lineObserver.disconnect();
      lineObserver = null;
    }
    return syncGen;
  }

  function nextCartReq() {
    return ++reqSeq;
  }

  function isCurrent(gen) {
    return gen == null || gen === syncGen;
  }

  function hasBssPricing() {
    return !!document.querySelector('[bss-b2b-cart-total-price], [bss-b2b-final-line-price]');
  }

  var BREAKS_KEY = 'mt_bss_qty_breaks';
  var qtyBreaks = {};
  try {
    qtyBreaks = JSON.parse(sessionStorage.getItem(BREAKS_KEY) || '{}') || {};
  } catch (e) {
    qtyBreaks = {};
  }

  function persistBreaks() {
    try {
      sessionStorage.setItem(BREAKS_KEY, JSON.stringify(qtyBreaks));
    } catch (e) {}
  }

  function parseQtyBound(text) {
    var raw = String(text || '');
    var range = raw.match(/(\d+)\s*[-–to]+\s*(\d+)/i);
    if (range) return { min: parseInt(range[1], 10), max: parseInt(range[2], 10) };
    var gte = raw.match(/(?:≥|>=|>\s*=)\s*(\d+)|(\d+)\s*\+|(\d+)\s*(?:or\s*more|\+)/i);
    if (gte) {
      var n = parseInt(gte[1] || gte[2] || gte[3], 10);
      return { min: n, max: Infinity };
    }
    var single = raw.match(/(\d+)/);
    if (single) return { min: parseInt(single[1], 10), max: Infinity };
    return null;
  }

  function parseDiscountCell(text) {
    var raw = String(text || '');
    var pct = raw.match(/(\d+(?:\.\d+)?)\s*%/);
    if (pct) return { percent: parseFloat(pct[1]), priceCents: 0 };
    var amounts = moneyAmountsInText(raw);
    if (amounts.length) return { percent: 0, priceCents: amounts[amounts.length - 1] };
    return null;
  }

  function productIdNear(el) {
    if (!el || !el.closest) return '';
    var node = el.closest('[data-product-id], product-info, .product, tr.cart-item');
    if (node && node.getAttribute('data-product-id')) return String(node.getAttribute('data-product-id'));
    var page = document.querySelector(
      'product-info[data-product-id], [id^="MainProduct-"][data-product-id], .product[data-product-id]'
    );
    if (page && page.getAttribute('data-product-id')) return String(page.getAttribute('data-product-id'));
    return '';
  }

  function harvestBreakTables() {
    document.querySelectorAll('table').forEach(function (table) {
      var text = table.textContent || '';
      if (!/%/.test(text) && !/\$/.test(text)) return;
      if (!/(\d+)\s*[-–]\s*(\d+)/.test(text) && !/(≥|>=|\+)/.test(text)) return;
      storeBreaksFromTable(table, productIdNear(table));
    });
    document
      .querySelectorAll(
        '.bss-b2b-qty-table-wrapper, .bss-b2b-cart-item-qty-table, .quantity_break_table, .bss-b2b-qb-table'
      )
      .forEach(function (el) {
        storeBreaksFromText(el.textContent, productIdNear(el));
      });
  }

  function storeBreaksFromTable(table, pid) {
    if (!pid || !table) return;
    var breaks = [];
    table.querySelectorAll('tr').forEach(function (tr) {
      var cells = tr.querySelectorAll('th, td');
      if (cells.length < 2) return;
      var bound = parseQtyBound(cells[0].textContent);
      var disc = parseDiscountCell(cells[1].textContent);
      if (!bound || !disc) return;
      if (!bound.min || (!disc.percent && !disc.priceCents)) return;
      breaks.push({
        min: bound.min,
        max: isFinite(bound.max) ? bound.max : 999999,
        percent: disc.percent || 0,
        priceCents: disc.priceCents || 0,
      });
    });
    if (breaks.length) {
      qtyBreaks[pid] = breaks;
      persistBreaks();
    }
  }

  function storeBreaksFromText(text, pid) {
    if (!pid || !text) return;
    var breaks = [];
    var re =
      /(?:(≥|>=|>\s*=)\s*)?(\d+)\s*(?:[-–]\s*(\d+))?[^%]{0,48}(\d+(?:\.\d+)?)\s*%/gi;
    var match;
    while ((match = re.exec(text))) {
      var min = parseInt(match[2], 10);
      var max = match[3] ? parseInt(match[3], 10) : match[1] ? 999999 : 999999;
      if (match[1] && !match[3]) max = 999999;
      else if (!match[1] && !match[3]) max = 999999;
      breaks.push({
        min: min,
        max: max,
        percent: parseFloat(match[4]),
        priceCents: 0,
      });
    }
    if (breaks.length) {
      qtyBreaks[pid] = breaks;
      persistBreaks();
    }
  }

  function breaksForProduct(productId) {
    if (!productId) return null;
    return qtyBreaks[String(productId)] || null;
  }

  function applyQtyBreak(origCents, qty, breaks) {
    if (!origCents || !qty || !breaks || !breaks.length) return origCents;
    var matched = null;
    for (var i = 0; i < breaks.length; i++) {
      var b = breaks[i];
      if (qty >= b.min && qty <= b.max) {
        if (!matched || b.min > matched.min) matched = b;
      }
    }
    if (!matched) return origCents;
    if (matched.priceCents > 0) return matched.priceCents;
    if (matched.percent > 0) {
      return Math.floor((origCents * (100 - matched.percent)) / 100);
    }
    return origCents;
  }

  function lineTotalCents(item) {
    if (!item) return 0;
    if (typeof item.final_line_price === 'number') return item.final_line_price;
    if (typeof item.line_price === 'number') return item.line_price;
    return 0;
  }

  function sumCartLines(cart) {
    var sum = 0;
    (cart.items || []).forEach(function (item) {
      sum += lineTotalCents(item);
    });
    return sum;
  }

  function parseOneMoneyToCents(raw) {
    if (!raw) return 0;
    var cleaned = String(raw).replace(/\s/g, '').replace(/[^\d.,-]/g, '');
    if (!cleaned) return 0;
    if (cleaned.indexOf(',') > -1 && cleaned.indexOf('.') > -1) {
      if (cleaned.lastIndexOf('.') > cleaned.lastIndexOf(',')) {
        cleaned = cleaned.replace(/,/g, '');
      } else {
        cleaned = cleaned.replace(/\./g, '').replace(',', '.');
      }
    } else if (cleaned.indexOf(',') > -1) {
      cleaned = cleaned.replace(',', '.');
    }
    var n = parseFloat(cleaned);
    return isNaN(n) ? 0 : Math.round(n * 100);
  }

  function moneyAmountsInText(text) {
    if (!text) return [];
    var matches = String(text).match(/-?\$?\d[\d,]*(?:\.\d{1,2})?/g);
    if (!matches) return [];
    var out = [];
    for (var i = 0; i < matches.length; i++) {
      var cents = parseOneMoneyToCents(matches[i]);
      if (cents > 0) out.push(cents);
    }
    return out;
  }

  function parseMoneyToCents(text) {
    var amounts = moneyAmountsInText(text);
    if (!amounts.length) return 0;
    return amounts[amounts.length - 1];
  }

  function visibleTextWithoutStrike(el) {
    if (!el) return '';
    var clone = el.cloneNode(true);
    clone
      .querySelectorAll('s, del, .cart-item__old-price, .visually-hidden, .bss-b2b-qb-table')
      .forEach(function (node) {
        node.remove();
      });
    return clone.textContent || '';
  }

  function lowestMoneyInEl(el) {
    var amounts = moneyAmountsInText(visibleTextWithoutStrike(el));
    if (!amounts.length) return 0;
    var min = amounts[0];
    for (var i = 1; i < amounts.length; i++) {
      if (amounts[i] < min) min = amounts[i];
    }
    return min;
  }

  function rowQty(row, item) {
    var input = row.querySelector('.quantity__input');
    if (input) {
      var v = parseInt(input.value, 10);
      if (!isNaN(v) && v > 0) return v;
    }
    return item && item.quantity ? item.quantity : 1;
  }

  function readRowOriginalUnitCents(row) {
    var el =
      row.querySelector('.cart-item__details .cart-item__old-price') ||
      row.querySelector('.cart-item__details s') ||
      row.querySelector('.cart-item__details [bss-b2b-item-original-price]');
    if (!el) return 0;
    var amounts = moneyAmountsInText(el.tagName === 'S' || el.classList.contains('cart-item__old-price') ? el.textContent : (el.querySelector('s, .cart-item__old-price') || el).textContent);
    if (!amounts.length) return 0;
    var max = amounts[0];
    for (var i = 1; i < amounts.length; i++) {
      if (amounts[i] > max) max = amounts[i];
    }
    return max;
  }

  function readRowUnitPriceCents(row) {
    var details = row.querySelector('.cart-item__details');
    if (!details) return 0;
    var finalEl =
      details.querySelector('[bss-b2b-item-final-price]') ||
      details.querySelector('.cart-item__final-price');
    // Read only the explicit final-price node. Scanning all details text also
    // parses amounts in product titles (e.g. “30-Minute”, “1 Litre”) as prices.
    var bssPriceWrapper = details.querySelector('[bss-b2b-item-original-price]');
    var originalEl = bssPriceWrapper
      ? (bssPriceWrapper.querySelector('.cart-item__old-price, s') || bssPriceWrapper)
      : details.querySelector('.cart-item__old-price, s');
    var unit = finalEl
      ? lowestMoneyInEl(finalEl)
      : (originalEl ? lowestMoneyInEl(originalEl) : 0);
    var original = readRowOriginalUnitCents(row);
    if (original > 0 && unit > original) unit = 0;
    return unit;
  }

  function paintUnitPrice(row, unitCents, originalCents) {
    var unitMoney = formatMoney(unitCents, LINE_MONEY_FORMAT);
    var finalEl =
      row.querySelector('.cart-item__details [bss-b2b-item-final-price]') ||
      row.querySelector('.cart-item__details .cart-item__final-price');
    if (finalEl) finalEl.textContent = unitMoney;
    var oldEl = row.querySelector('.cart-item__details .cart-item__old-price');
    if (oldEl) {
      if (originalCents > unitCents) {
        oldEl.textContent = formatMoney(originalCents, LINE_MONEY_FORMAT);
        oldEl.hidden = false;
        oldEl.removeAttribute('hidden');
      } else {
        oldEl.hidden = true;
        oldEl.setAttribute('hidden', '');
      }
    }
  }

  /**
   * BSS's authoritative per-line pricing: cartStorage rows carry
   * bssB2BPriceAfterPL/CP/QB/DC/Bogo vs original_price (shop currency).
   * Return a 0..1 ratio so it can be applied to the market-currency DOM price.
   */
  function bssStoragePriceRatio(key) {
    try {
      var storage = window.BSS_B2B && window.BSS_B2B.storage && window.BSS_B2B.storage.cartStorage;
      if (!storage || typeof storage.getAll !== 'function') return 0;
      var all = storage.getAll();
      if (!all) return 0;
      var values = all instanceof Map ? Array.from(all.values()) : Object.values(all);
      var row = null;
      for (var i = 0; i < values.length; i++) {
        var r = values[i];
        if (r && (String(r.key || '') === String(key))) { row = r; break; }
      }
      if (!row) return 0;
      var after = [row.bssB2BPriceAfterPL, row.bssB2BPriceAfterCP, row.bssB2BPriceAfterQB, row.bssB2BPriceAfterDC, row.bssB2BPriceAfterBogo];
      var best = 0;
      for (var j = 0; j < after.length; j++) {
        var p = Number(after[j]);
        if (p > 0 && (!best || p < best)) best = p;
      }
      var orig = Number(row.original_price);
      if (!best || !orig || orig <= 0 || best >= orig) return 0;
      return best / orig;
    } catch (e) {
      return 0;
    }
  }

  function bssLineCentsForRow(row, item) {
    var origUnitCents =
      readRowOriginalUnitCents(row) ||
      (item && typeof item.original_price === 'number' ? item.original_price : 0);
    var qty = rowQty(row, item);
    var pid =
      (row && row.getAttribute('data-product-id')) ||
      (item && item.product_id) ||
      '';
    var breaks = breaksForProduct(pid);
    var lineKey = (item && item.key) || (row && row.getAttribute('data-cart-item-key')) || '';
    var storageRatio = bssStoragePriceRatio(lineKey);
    var unitCents = 0;
    if (storageRatio > 0 && origUnitCents > 0) {
      // Authoritative BSS discount ratio applied to the market-currency original.
      unitCents = Math.round(origUnitCents * storageRatio);
    }
    // DOM final price may already carry BSS's painted discount (storage can lag);
    // prefer whichever source is actually discounted — never overwrite a
    // discounted price with a retail one.
    var domUnitCents = readRowUnitPriceCents(row);
    if (domUnitCents > 0 && (!unitCents || domUnitCents < unitCents)) {
      unitCents = domUnitCents;
    }
    if (!unitCents) unitCents = origUnitCents;
    if (breaks && breaks.length && origUnitCents > 0) {
      // Qty-break harvest is a fallback — never let an unmatched tier (which
      // returns retail) clobber a BSS partner price from storage or the DOM.
      var breakUnit = applyQtyBreak(origUnitCents, qty, breaks);
      if (breakUnit > 0 && breakUnit < unitCents) unitCents = breakUnit;
    }
    if (unitCents <= 0) return null;
    return {
      unitCents: unitCents,
      lineCents: unitCents * qty,
      originalUnitCents: origUnitCents,
      originalLineCents: origUnitCents > unitCents ? origUnitCents * qty : 0,
    };
  }

  function paintLineTotal(row, lineCents, originalLineCents) {
    var lineMoney = formatMoney(lineCents, LINE_MONEY_FORMAT);
    var targets = row.querySelectorAll(
      '.cart-item__totals [bss-b2b-final-line-price], .cart-item__totals .price.price--end:not(.cart-item__old-price)'
    );
    if (!targets.length) {
      var fallback = row.querySelector('.cart-item__totals .price');
      if (fallback) targets = [fallback];
    }
    for (var i = 0; i < targets.length; i++) {
      setLinePriceElement(targets[i], lineMoney);
    }

    var oldEl = row.querySelector('.cart-item__totals .cart-item__old-price');
    if (oldEl && originalLineCents > lineCents) {
      oldEl.textContent = formatMoney(originalLineCents, LINE_MONEY_FORMAT);
      oldEl.removeAttribute('hidden');
      oldEl.hidden = false;
    }

    var unitOld = row.querySelector('.cart-item__details .cart-item__old-price');
    if (unitOld && originalLineCents > lineCents) {
      unitOld.removeAttribute('hidden');
      unitOld.hidden = false;
    }

    row.querySelectorAll('.cart-item__price-wrapper, .cart-item__totals .price').forEach(function (el) {
      el.style.visibility = 'visible';
      el.style.filter = 'none';
    });
  }

  function sumVisibleLineTotalsCents() {
    var sum = 0;
    var drawer = document.querySelector('cart-drawer');
    var spId = drawer && drawer.getAttribute('data-shipping-id');
    document
      .querySelectorAll('#CartDrawer tr.cart-item, #main-cart-items tr.cart-item')
      .forEach(function (row) {
        // Shipping protection is added separately by computeDisplayTotal; exclude
        // its DOM line here to avoid counting it twice when BSS markup is present.
        var rowVariantId = row.getAttribute('data-variant-id') || '';
        var nameEl = row.querySelector('.cart-item__name');
        var rowTitle = String(nameEl ? nameEl.textContent : '').toLowerCase();
        if ((spId && String(rowVariantId) === String(spId)) || rowTitle.indexOf('shipping protection') !== -1) return;

        var bssLine = bssLineCentsForRow(row, null);
        if (bssLine && bssLine.lineCents > 0) {
          sum += bssLine.lineCents;
          return;
        }
        var totals = row.querySelector('.cart-item__totals');
        if (!totals) return;
        var priceEl =
          totals.querySelector('[bss-b2b-final-line-price]') ||
          totals.querySelector('.price--end:not(.cart-item__old-price)') ||
          totals.querySelector('.price');
        if (priceEl) sum += lowestMoneyInEl(priceEl) || parseMoneyToCents(priceEl.textContent);
      });
    return sum;
  }

  function spLineCents(cart) {
    // SP at its original (pre-code) price — a product-targeted discount code
    // reports as a line-level allocation inside line_price, so always prefer
    // original_line_price (SM08-19: codes never show in totals).
    var sp = 0;
    (cart.items || []).forEach(function (item) {
      if (isSpLine(item)) {
        sp +=
          typeof item.original_line_price === 'number'
            ? item.original_line_price
            : lineTotalCents(item);
      }
    });
    return sp;
  }

  function spPriceFromDom() {
    var box = document.querySelector('.shipping_protection_box[data-sp-price]');
    if (box) {
      var n = parseInt(box.getAttribute('data-sp-price'), 10);
      if (!isNaN(n) && n > 0) return n;
    }
    return 199;
  }

  /** Market-currency SP price: prefer the rendered (£-converted) box text over
      the raw variant cents attr (shop currency). */
  function spMarketPriceCents() {
    var el = document.querySelector('.shipping_protection_box .price');
    if (el) {
      var cents = parseMoneyToCents(el.textContent);
      if (cents > 0) return cents;
    }
    return spPriceFromDom();
  }

  function spWantedOn() {
    try {
      if (typeof window.mtSpIsOn === 'function') return window.mtSpIsOn();
      var pref = localStorage.getItem('mt_sp_pref') || sessionStorage.getItem('mt_sp_pref');
      if (pref === 'off') return false;
      if (pref === 'on') return true;
      if (sessionStorage.getItem('mt_sp_opt_out') === '1') return false;
    } catch (e) {}
    return true;
  }

  function spAddonCents(cart) {
    if (!spWantedOn()) return 0;
    var fromCart = spLineCents(cart);
    if (fromCart > 0) return fromCart;
    return spMarketPriceCents();
  }

  /** SP contribution to the display total — always the code-free original
      price (see spLineCents). Aliased for the B2B path for readability. */
  function spChargedCents(cart) {
    return spLineCents(cart);
  }

  /**
   * BSS DOM-vs-server comparison. convRatio is the observed market-currency
   * conversion factor (DOM cents ÷ cart.js cents), anchored on the SP line —
   * SP is never B2B-repriced, so its ratio is pure currency conversion.
   * repriced is true when any merchandise line deviates from that anchor
   * (B2B price lists, or a spurious repaint on a guest session).
   */
  function bssDomVsServer(cart) {
    var result = { repriced: true, convRatio: 0 };
    try {
      var merchByVariant = {};
      var spCartCents = 0;
      (cart.items || []).forEach(function (item) {
        if (isSpLine(item)) {
          spCartCents += lineTotalCents(item);
          return;
        }
        var v = String(item.variant_id || item.id || '');
        if (v) merchByVariant[v] = (merchByVariant[v] || 0) + lineTotalCents(item);
      });
      var domByVariant = {};
      document
        .querySelectorAll('#CartDrawer tr.cart-item, #main-cart-items tr.cart-item')
        .forEach(function (row) {
          var nameEl = row.querySelector('.cart-item__name');
          var title = String(nameEl ? nameEl.textContent : '').toLowerCase();
          if (title.indexOf('shipping protection') !== -1) return;
          var v = String(row.getAttribute('data-variant-id') || '');
          if (!v || !merchByVariant[v]) return;
          var cents = 0;
          var bssLine = bssLineCentsForRow(row, null);
          if (bssLine && bssLine.lineCents > 0) cents = bssLine.lineCents;
          if (!cents) {
            var totals = row.querySelector('.cart-item__totals');
            var priceEl =
              totals &&
              (totals.querySelector('[bss-b2b-final-line-price]') ||
                totals.querySelector('.price--end:not(.cart-item__old-price)') ||
                totals.querySelector('.price'));
            if (priceEl) cents = parseMoneyToCents(priceEl.textContent);
          }
          if (cents > 0) domByVariant[v] = (domByVariant[v] || 0) + cents;
        });
      var ratios = [];
      Object.keys(merchByVariant).forEach(function (v) {
        if (domByVariant[v] > 0) ratios.push(domByVariant[v] / merchByVariant[v]);
      });
      if (!ratios.length) return result;
      ratios.sort(function (a, b) {
        return a - b;
      });
      var spMarket = spCartCents > 0 ? spMarketPriceCents() : 0;
      var anchor = spCartCents > 0 && spMarket > 0 ? spMarket / spCartCents : ratios[Math.floor(ratios.length / 2)];
      result.convRatio = anchor;
      for (var i = 0; i < ratios.length; i++) {
        if (Math.abs(ratios[i] - anchor) / anchor > 0.025) return result;
      }
      result.repriced = false;
      return result;
    } catch (e) {
      return result;
    }
  }

  /** True when BSS reports a logged-in customer session (B2B price lists are
      legitimate only then; guests get spurious repaints we must ignore). */
  function bssCustomerSession() {
    try {
      var c = window.BSS_B2B && window.BSS_B2B.shopData && window.BSS_B2B.shopData.customer;
      return !!(c && c.id != null);
    } catch (e) {
      return false;
    }
  }

  function computeDisplayTotal(cart) {
    if (!cart) return 0;
    var lineSum = sumCartLines(cart);
    /* SM08-19: cart-level discount codes must not appear in the drawer/cart
       total — they do not carry to BSS checkout and their UI was removed.
       items_subtotal_price keeps line-level discounts but excludes cart-level
       codes; fall back to the line sum (final_line_price never includes
       cart-level codes) if the field is missing. */
    var shopifyTotal =
      typeof cart.items_subtotal_price === 'number'
        ? cart.items_subtotal_price
        : typeof cart.total_price === 'number'
          ? cart.total_price
          : lineSum;
    var spCents = spAddonCents(cart);

    if (hasBssPricing()) {
      var domSum = sumVisibleLineTotalsCents();
      // domSum covers merchandise rows only — the drawer never renders SP as a
      // line — so always add the SP amount on top.
      if (domSum > 0) {
        var comparison = bssDomVsServer(cart);
        if (!comparison.repriced || !bssCustomerSession()) {
          // No genuine BSS repricing (pure currency conversion, or a guest
          // session BSS repainting anyway): trust the pre-code server subtotal
          // (see SM08-19 note above) converted to drawer currency via the
          // SP-anchored ratio.
          if (comparison.convRatio > 0) {
            var spInCart = spLineCents(cart);
            var merchServer = spInCart > 0 ? Math.max(0, shopifyTotal - spInCart) : shopifyTotal;
            var spMarket = spInCart > 0 ? Math.round(spInCart * comparison.convRatio) : spCents;
            return Math.round(merchServer * comparison.convRatio) + spMarket;
          }
        }
        // B2B session with genuine BSS repricing: build the total from actual
        // values only — the BSS line prices (storage/DOM) plus the SP line at
        // its original (code-free) price, converted to market currency via
        // the SP-anchored ratio. Cart-level discount ratios are derived from
        // RETAIL allocations and must never be blended into partner prices:
        // they invented phantom discounts (e.g. $14.51 for a $13.90 B2B line
        // + $1.99 SP) whenever a code was attached to the cart. The BSS lines
        // themselves stay as painted; whether BSS checkout honors a
        // cart-level code is not knowable client-side, so the estimate
        // mirrors what is displayed, never a blended guess.
        var spCharged = spChargedCents(cart);
        if (spCharged > 0 && comparison.convRatio > 0) {
          spCharged = Math.round(spCharged * comparison.convRatio);
        }
        if (!spWantedOn()) spCharged = 0;
        else if (!spCharged) spCharged = spCents;
        return domSum + spCharged;
      }
    }

    if (spWantedOn() && spLineCents(cart) === 0) return shopifyTotal + spCents;
    if (!spWantedOn() && spLineCents(cart) > 0) {
      return Math.max(0, shopifyTotal - spLineCents(cart));
    }
    return shopifyTotal;
  }

  function revealCartItemPrices() {
    document
      .querySelectorAll(
        '#CartDrawer .cart-item .loading__spinner, cart-drawer-items .cart-item .loading__spinner, #main-cart-items .cart-item .loading__spinner'
      )
      .forEach(function (el) {
        el.classList.add('hidden');
      });
    var itemsRoot =
      document.getElementById('CartDrawer-CartItems') ||
      document.getElementById('main-cart-items');
    if (itemsRoot) itemsRoot.classList.remove('cart__items--disabled');
  }

  function totalNodes() {
    return document.querySelectorAll(
      '#CartDrawer .totals__total-value, .cart-drawer__footer .totals__total-value, #main-cart-footer .totals__total-value, [bss-b2b-cart-total-price], .cart--totalsss'
    );
  }

  function writeEstimatedTotal(cents) {
    var money = formatMoney(cents, MONEY_FORMAT);
    totalNodes().forEach(function (el) {
      el.textContent = money;
      el.style.filter = 'none';
      el.style.visibility = 'visible';
    });
    window.afterpay_cart_total_price = cents;
    lastDisplayTotal = cents;
    // Keep dependent UI (free-shipping progress, etc.) on the same market/BSS
    // total rendered into the drawer instead of Shopify's stale cart.js total.
    if (typeof window.mtUpdateFreeShippingBars === 'function') {
      window.mtUpdateFreeShippingBars(cents);
    }
    return money;
  }

  function setLinePriceElement(el, money) {
    if (!el) return;
    if (el.tagName === 'S' || (el.classList && el.classList.contains('cart-item__old-price'))) return;
    var finalPrice =
      el.querySelector('.cart-item__final-price') ||
      el.querySelector('span.price.price--end:not(s):not(.cart-item__old-price)');
    if (finalPrice && finalPrice !== el && finalPrice.tagName !== 'S') {
      finalPrice.textContent = money;
    } else {
      el.textContent = money;
    }
    el.style.filter = 'none';
    el.style.visibility = 'visible';
  }

  function findCartRowByKey(key) {
    if (!key) return null;
    var rows = document.querySelectorAll(
      '#CartDrawer tr.cart-item[data-cart-item-key], #CartDrawer tr.cart-item[bss-b2b-cart-item-key], #main-cart-items tr.cart-item[data-cart-item-key], #main-cart-items tr.cart-item[bss-b2b-cart-item-key]'
    );
    for (var i = 0; i < rows.length; i++) {
      if (
        rows[i].getAttribute('data-cart-item-key') === key ||
        rows[i].getAttribute('bss-b2b-cart-item-key') === key
      ) {
        return rows[i];
      }
    }
    return null;
  }

  function writeLinePrices(cart) {
    harvestBreakTables();
    (cart.items || []).forEach(function (item) {
      if (isSpLine(item)) return;
      var row = findCartRowByKey(item.key);
      if (!row) return;

      if (hasBssPricing()) {
        var bssLine = bssLineCentsForRow(row, item);
        if (!bssLine) return;
        // Never overwrite an already-discounted BSS paint with retail math.
        if (bssLine.originalUnitCents > 0 && bssLine.unitCents >= bssLine.originalUnitCents) return;
        paintUnitPrice(row, bssLine.unitCents, bssLine.originalUnitCents || 0);
        paintLineTotal(row, bssLine.lineCents, bssLine.originalLineCents);
        return;
      }

      var lineCents = lineTotalCents(item);
      var lineMoney = formatMoney(lineCents, LINE_MONEY_FORMAT);
      var targets = row.querySelectorAll('[bss-b2b-final-line-price]');
      if (targets.length) {
        targets.forEach(function (el) {
          setLinePriceElement(el, lineMoney);
        });
      } else {
        var fallback = row.querySelector(
          '.cart-item__price-wrapper .price.price--end, .cart-item__totals .price'
        );
        if (fallback) {
          fallback.textContent = lineMoney;
          fallback.style.visibility = 'visible';
        }
      }

      row.querySelectorAll('.cart-item__price-wrapper, .cart-item__totals .price').forEach(
        function (el) {
          el.style.visibility = 'visible';
          el.style.filter = 'none';
        }
      );
    });
  }

  function clearTotalLock() {
    lockedMoney = null;
    lockedGen = 0;
    if (lockTimer) {
      clearTimeout(lockTimer);
      lockTimer = null;
    }
    if (totalObserver) {
      totalObserver.disconnect();
      totalObserver = null;
    }
  }

  function lockEstimatedTotal(cents, gen) {
    if (!isCurrent(gen)) return;
    lockedMoney = formatMoney(cents, MONEY_FORMAT);
    lockedGen = gen;

    if (totalObserver) totalObserver.disconnect();
    totalObserver = new MutationObserver(function () {
      if (lockedGen !== syncGen || !lockedMoney) return;
      totalNodes().forEach(function (el) {
        if (el.textContent !== lockedMoney) {
          el.textContent = lockedMoney;
          el.style.filter = 'none';
          el.style.visibility = 'visible';
        }
      });
    });
    totalNodes().forEach(function (el) {
      totalObserver.observe(el, { characterData: true, childList: true, subtree: true });
    });

    if (lockTimer) clearTimeout(lockTimer);
    lockTimer = setTimeout(function () {
      lockTimer = null;
      if (totalObserver) {
        totalObserver.disconnect();
        totalObserver = null;
      }
      if (lockedGen === syncGen) {
        lockedMoney = null;
        lockedGen = 0;
      }
    }, 1800);
  }

  function lockPaintedTotal(gen) {
    if (gen == null) gen = syncGen;
    if (!isCurrent(gen)) return;
    if (hasBssPricing()) return;
    var el = document.querySelector(
      '#CartDrawer .totals__total-value, .cart-drawer__footer .totals__total-value'
    );
    if (!el) return;
    var text = (el.textContent || '').trim();
    if (!text) return;
    revealCartItemPrices();
    lockedMoney = text;
    lockedGen = gen;
    if (totalObserver) totalObserver.disconnect();
    totalObserver = new MutationObserver(function () {
      if (lockedGen !== syncGen || !lockedMoney) return;
      totalNodes().forEach(function (node) {
        if (node.textContent !== lockedMoney) {
          node.textContent = lockedMoney;
          node.style.filter = 'none';
          node.style.visibility = 'visible';
        }
      });
    });
    totalNodes().forEach(function (node) {
      totalObserver.observe(node, { characterData: true, childList: true, subtree: true });
    });
    if (lockTimer) clearTimeout(lockTimer);
    lockTimer = setTimeout(function () {
      lockTimer = null;
      if (totalObserver) {
        totalObserver.disconnect();
        totalObserver = null;
      }
    }, 1500);
  }

  function isFullCart(cart) {
    return (
      cart &&
      typeof cart.total_price === 'number' &&
      typeof cart.item_count === 'number' &&
      Array.isArray(cart.items)
    );
  }

  function isSpLine(item) {
    if (!item) return false;
    var drawer = document.querySelector('cart-drawer');
    var spId = drawer ? drawer.getAttribute('data-shipping-id') : '';
    var vid = String(item.variant_id || item.id || '');
    if (spId && vid === String(spId)) return true;
    var title = String(item.product_title || item.title || '').toLowerCase();
    return title.indexOf('shipping protection') !== -1;
  }

  function visibleDrawerKeys() {
    var keys = [];
    document.querySelectorAll('#CartDrawer tr.cart-item[data-cart-item-key]').forEach(function (row) {
      var key = row.getAttribute('data-cart-item-key');
      if (key) keys.push(key);
    });
    keys.sort();
    return keys;
  }

  function cartProductKeys(cart) {
    var keys = [];
    (cart.items || []).forEach(function (item) {
      if (isSpLine(item)) return;
      if (item.key) keys.push(item.key);
    });
    keys.sort();
    return keys;
  }

  function isStaleCart(cart) {
    var domKeys = visibleDrawerKeys();
    if (!domKeys.length) return false;
    var cartKeys = cartProductKeys(cart);
    if (cartKeys.length < domKeys.length) return true;
    for (var i = 0; i < domKeys.length; i++) {
      if (cartKeys.indexOf(domKeys[i]) === -1) return true;
    }
    return false;
  }

  function notifyBss() {
    try {
      var observer = window.BSS_B2B && window.BSS_B2B.observer;
      if (!observer) return;
      ['cartSubject', 'productSubject'].forEach(function (name) {
        var subject = observer[name];
        if (!subject || typeof subject.notifyObserver !== 'function') return;
        try {
          subject.notifyObserver('CartMutate', 'CartPriceMutate');
        } catch (e1) {}
        try {
          subject.notifyObserver('ProductMutate', 'ProductPriceMutate');
        } catch (e2) {}
      });
    } catch (e) {}
  }

  /**
   * Official BSS paint hooks (window.bssB2bHooks, bound early in theme.liquid):
   * BSS fires custom:cart/showPrice after painting line prices and
   * custom:cart/showSubtotalPrice after painting the cart subtotal. Recompute
   * the estimated total (BSS lines + shipping protection) from the freshly
   * painted DOM instead of racing our own timers against BSS repaints.
   */
  function onBssCartPaint() {
    if (!lastGoodCart) return;
    requestAnimationFrame(function () {
      if (!lastGoodCart || isStaleCart(lastGoodCart)) return;
      revealCartItemPrices();
      writeLinePrices(lastGoodCart);
      var displayTotal = computeDisplayTotal(lastGoodCart);
      if (displayTotal > 0) {
        writeEstimatedTotal(displayTotal);
        lockEstimatedTotal(displayTotal, syncGen);
      }
    });
  }

  /* True once hooks are registered through BSS_B2B.custom.addAction.
     Guards against duplicate registration now that registerBssPaintHooks()
     also runs lazily from syncCartTotals. */
  var bssHooksBridgeRegistered = false;

  function registerBssPaintHooks() {
    if (bssHooksBridgeRegistered) return;
    window.bssB2bHooks = window.bssB2bHooks || { actions: {}, filters: {} };
    var hooks = window.BSS_B2B && window.BSS_B2B.custom;
    if (hooks && typeof hooks.addAction === 'function') {
      try {
        hooks.addAction('custom:cart/showSubtotalPrice', onBssCartPaint);
        hooks.addAction('custom:cart/showPrice', onBssCartPaint);
        bssHooksBridgeRegistered = true;
        return;
      } catch (e) {
        /* fall through to the registry-object fallback below */
      }
    }
    window.bssB2bHooks.actions['custom:cart/showSubtotalPrice'] = onBssCartPaint;
    window.bssB2bHooks.actions['custom:cart/showPrice'] = onBssCartPaint;
  }

  function bssDiscountReady() {
    var rows = document.querySelectorAll('#CartDrawer tr.cart-item, #main-cart-items tr.cart-item');
    for (var i = 0; i < rows.length; i++) {
      var line = bssLineCentsForRow(rows[i], null);
      if (line && line.originalLineCents > line.lineCents) return true;
    }
    return false;
  }

  function lockDiscountedLineTotals(gen) {
    if (lineObserver) {
      lineObserver.disconnect();
      lineObserver = null;
    }
  }

  function syncCartTotals(cart, gen) {
    if (!isCurrent(gen)) return;
    if (!isFullCart(cart)) return;

    /* Lazy hook registration: BSS is script-gated and can initialize long after
       the page-load retry window. Any cart update that can produce a BSS repaint
       must first guarantee a paint listener exists — registering here (before
       notifyBss below) does that without timers. Idempotent via the bridge flag. */
    registerBssPaintHooks();

    revealCartItemPrices();
    harvestBreakTables();
    writeLinePrices(cart);
    var displayTotal = computeDisplayTotal(cart);
    writeEstimatedTotal(displayTotal);
    if (!hasBssPricing() || bssDiscountReady()) {
      lockEstimatedTotal(displayTotal, gen);
      lockDiscountedLineTotals(gen);
    }
    lastGoodCart = cart;
    window.__mtLastSyncedCart = cart;
    notifyBss();
  }

  function applyCartSync(cart, gen, req) {
    if (!isFullCart(cart)) return;
    if (req == null || req < minReq || req < lastAppliedReq) return;
    if (gen != null && !isCurrent(gen)) return;
    if (isStaleCart(cart)) {
      pendingApply = { cart: cart, gen: gen, req: req };
      return;
    }
    pendingApply = null;
    lastAppliedReq = req;
    if (gen == null) gen = syncGen;
    syncCartTotals(cart, gen);
  }

  function flushPendingCart() {
    if (!pendingApply) return;
    var pending = pendingApply;
    pendingApply = null;
    applyCartSync(pending.cart, pending.gen, pending.req);
  }

  function reapplyLastCart() {
    if (pendingApply) {
      flushPendingCart();
      return;
    }
    if (!lastGoodCart) return;
    if (isStaleCart(lastGoodCart)) return;
    revealCartItemPrices();
    writeLinePrices(lastGoodCart);
    var total =
      lastDisplayTotal > 0 ? lastDisplayTotal : computeDisplayTotal(lastGoodCart);
    writeEstimatedTotal(total);
    lockEstimatedTotal(total, syncGen);
  }

  function syncFromPayload(payload) {
    if (
      payload &&
      (payload.source === 'product-form' ||
        payload.source === 'cart-drawer-render' ||
        payload.source === 'cart-items' ||
        payload.source === 'sp-enforcement' ||
        payload.source === 'cart-refresh')
    ) {
      return;
    }
    var cart = payload && payload.cartData;
    if (isFullCart(cart)) applyCartSync(cart, null, nextCartReq());
  }

  function paintDrawerFromHtml(text) {
    var doc = new DOMParser().parseFromString(text, 'text/html');
    var liveInner = document.querySelector('cart-drawer .drawer__inner');
    var nextInner = doc.querySelector('.drawer__inner');
    if (liveInner && nextInner) {
      liveInner.replaceWith(nextInner);
    } else {
      ['cart-drawer-items', '.cart-drawer__footer', '[data-free-shipping-bar]'].forEach(function (sel) {
        var live = document.querySelector(sel);
        var next = doc.querySelector(sel);
        if (live && next) live.replaceWith(next);
      });
    }
    var overlay = document.querySelector('#CartDrawer-Overlay');
    var drawer = document.querySelector('cart-drawer');
    if (overlay && drawer && typeof drawer.close === 'function') {
      overlay.addEventListener('click', drawer.close.bind(drawer));
    }
    revealCartItemPrices();
    if (typeof window.mtSyncSPSwitcher === 'function') {
      window.mtSyncSPSwitcher(lastGoodCart);
    }
    if (lastGoodCart) {
      requestAnimationFrame(function () {
        syncCartTotals(lastGoodCart, syncGen);
      });
    }
  }

  window.mtBeginCartSync = beginCartSync;
  window.mtNextCartReq = nextCartReq;
  window.mtIsCartSyncCurrent = isCurrent;
  window.mtSyncCartTotals = applyCartSync;
  window.mtRevealCartItemPrices = revealCartItemPrices;
  window.mtLockPaintedTotal = lockPaintedTotal;
  window.mtFlushPendingCart = flushPendingCart;
  window.mtComputeCartDisplayTotal = computeDisplayTotal;
  window.mtLockEstimatedTotal = lockEstimatedTotal;
  window.mtGetBssPriceSnapshot = function () {
    var rows = [];
    document.querySelectorAll('#CartDrawer tr.cart-item, #main-cart-items tr.cart-item').forEach(function (row) {
      var line = bssLineCentsForRow(row, null);
      if (line) rows.push({ variantId: row.getAttribute('data-variant-id'), unitCents: line.unitCents, lineCents: line.lineCents, originalUnitCents: line.originalUnitCents });
    });
    return { active: hasBssPricing(), discounted: bssDiscountReady(), rows: rows };
  };

  /** Paste window.mtCartDebug() in console when the drawer total looks wrong. */
  window.mtCartDebug = function () {
    var out = {
      bssLoaded: !!(window.BSS_B2B && window.BSS_B2B.observer),
      bssHooksBridgeRegistered: bssHooksBridgeRegistered,
      hooksRegistered: {},
      rows: [],
      totals: [],
      lastCart: null,
      computed: null,
      lastDisplayTotal: lastDisplayTotal,
    };
    try {
      var actions = (window.bssB2bHooks && window.bssB2bHooks.actions) || {};
      out.hooksRegistered = {
        showSubtotalPrice: typeof actions['custom:cart/showSubtotalPrice'],
        showPrice: typeof actions['custom:cart/showPrice'],
      };
    } catch (e) {}
    document.querySelectorAll('#CartDrawer tr.cart-item, #main-cart-items tr.cart-item').forEach(function (row) {
      var key = row.getAttribute('data-cart-item-key') || row.getAttribute('bss-b2b-cart-item-key');
      out.rows.push({
        key: key,
        title: (row.querySelector('.cart-item__name') || {}).textContent,
        qty: rowQty(row, null),
        origUnit: readRowOriginalUnitCents(row),
        domUnit: readRowUnitPriceCents(row),
        storageRatio: bssStoragePriceRatio(key),
        totalsCellText: (row.querySelector('.cart-item__totals .price--end:not(.cart-item__old-price)') || {}).textContent,
      });
    });
    totalNodes().forEach(function (el) {
      out.totals.push({ text: el.textContent, cls: el.className });
    });
    if (lastGoodCart) {
      out.lastCart = (lastGoodCart.items || []).map(function (i) {
        return { key: i.key, qty: i.quantity, price: i.price, final: i.final_price, line: i.final_line_price };
      });
      out.computed = computeDisplayTotal(lastGoodCart);
    }
    return out;
  };

  window.mtWaitForBssCartPricing = function (variantId, timeoutMs) {
    timeoutMs = timeoutMs || 5000;
    var started = Date.now();
    return new Promise(function (resolve) {
      (function check() {
        // Guests / BSS-not-loaded: no partner pricing will ever land — stop
        // immediately instead of polling the DOM for the full timeout.
        if (!(window.BSS_B2B && window.BSS_B2B.observer)) {
          resolve(window.mtGetBssPriceSnapshot());
          return;
        }
        notifyBss();
        var snapshot = window.mtGetBssPriceSnapshot();
        var target = snapshot.rows.find(function (row) {
          return String(row.variantId) === String(variantId);
        });
        if (!snapshot.active || (target && target.originalUnitCents > target.unitCents) || Date.now() - started >= timeoutMs) {
          resolve(snapshot);
          return;
        }
        setTimeout(check, 100);
      })();
    });
  };

  if (!drawerObserver && typeof MutationObserver === 'function') {
    function bindDrawerObserver() {
      var drawer = document.getElementById('CartDrawer');
      if (!drawer || drawerObserver) return;
      drawerObserver = new MutationObserver(function () {
        if (!lastGoodCart) return;
        if (reapplyQueued) return;
        reapplyQueued = true;
        requestAnimationFrame(function () {
          reapplyQueued = false;
          flushPendingCart();
          if (lastGoodCart && !isStaleCart(lastGoodCart)) reapplyLastCart();
        });
      });
      drawerObserver.observe(drawer, { childList: true, subtree: true });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bindDrawerObserver);
    } else {
      bindDrawerObserver();
    }
  }

  /* Register paint hooks ASAP (window.bssB2bHooks exists from theme.liquid);
     if BSS_B2B.custom appears later, re-register through the official bridge. */
  registerBssPaintHooks();
  (function retryRegister(attempts) {
    if (window.BSS_B2B && window.BSS_B2B.custom && typeof window.BSS_B2B.custom.addAction === 'function') {
      registerBssPaintHooks();
      return;
    }
    if (attempts > 0) setTimeout(function () { retryRegister(attempts - 1); }, 500);
  })(20);

  function bindPubSub() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, syncFromPayload);
      return true;
    }
    return false;
  }

  if (!bindPubSub()) {
    document.addEventListener('DOMContentLoaded', bindPubSub);
    setTimeout(bindPubSub, 0);
  }

  function bindBreakHarvest() {
    harvestBreakTables();
    [400, 1000, 2000].forEach(function (delay) {
      setTimeout(harvestBreakTables, delay);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindBreakHarvest);
  } else {
    bindBreakHarvest();
  }
})();
